import { Routes } from '@angular/router';
import { RoleGuard } from '../../core/guard/role.guard';
import { hrAccionesRoles } from 'src/app/settings/acciones-roles/departamentos/hr-acciones-roles';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'uploads' },

  {
    path: 'uploads',
    loadComponent: () =>
      import('./view-uploads/view-uploads.component').then(
        (m) => m.HrViewUploadsComponent
      ),
    canActivate: [RoleGuard],
    data: {
      pageTitle: 'Recursos Humanos',
      breadcrumb: 'HR',
      expectedRole: hrAccionesRoles.sharedActions.uploads,
    },
  },
];

export const HrDepartmentRoutes = {
  path: 'hr',
  children: routes,
};
